module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "landing-hero"
  }, [_c('div', {
    staticClass: "inner-container"
  }, [_c('div', {
    staticClass: "flex-container"
  }, [_c('div', {
    staticClass: "text-content"
  }, [_c('h1', {
    staticClass: "section-title"
  }, [_vm._v("Seu próximo trabalho pode revolucionar o empreendedorismo no Brasil")]), _vm._v(" "), _c('p', [_vm._v("Faça parte do Moip e ajude a construir grandes histórias de sucesso. Tudo isso cercado de colegas talentosos, um lindo ambiente de trabalho e benefícios incríveis.")])]), _vm._v(" "), _c('div', {
    staticClass: "image-content"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-638d7e1d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingHero.vue
// module id = 140
// module chunks = 1